var _circle, _circle2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgScooter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 82,
    viewBox: "0 0 86 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 69.828,
    r: 10.5,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 69.828,
    r: 2.5,
    fill: "#504FE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 69.828c0 5.8-4.701 10.5-10.5 10.5s-10.5-4.7-10.5-10.5M84 68.328c0-8.836-6.94-16-15.5-16-8.56 0-15.5 7.164-15.5 16",
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.099 47.828l3.734-17.706a1 1 0 01.978-.794h4.953c.155 0 .309.035.444.11C29.265 30.574 33 34.143 33 40.328V55.83a3 3 0 003 3h11.253a1 1 0 00.96-.717l3.575-12.068a1 1 0 01.959-.716H69c13.892 0 15.871 14.891 15.096 23.125a.974.974 0 01-.979.875H23m-5.901-21.5v11.5H1.967c-.537 0-.983-.423-.942-.959.317-4.193 3.79-10.54 16.074-10.54z",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.328a6 6 0 016-6h12a1 1 0 011 1v10a1 1 0 01-1 1H21a6 6 0 01-6-6v0zM47 42.055a8.727 8.727 0 018.727-8.727H78a6 6 0 016 6v0a6 6 0 01-6 6H50.273A3.273 3.273 0 0147 42.055v0z",
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23.828h9.5M51.5 10.328h25m-16 11H85",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgScooter;